
(function () {
	"use strict";


    function updateDeviceRouteState(id){
        let request = new XMLHttpRequest();
       /* let curr = document.getElementById('curr');
        let next = document.getElementById('next');
        let prev = document.getElementById('prev');*/



        request.onreadystatechange = function () {


			
			if (request.readyState === 4) {
				if (request.status === 200 || request.status === 201) {
                    let routeDeviceStateJSON = JSON.parse(request.responseText);


                    let curr = document.getElementById(routeDeviceStateJSON.routeDeviceState.currStop._id);

                    curr.innerHTML = curr.innerHTML + " (curr)";
                    let next = document.getElementById(routeDeviceStateJSON.routeDeviceState.nextStop);

                    next.innerHTML = next.innerHTML + " (next)";
                    let prev = document.getElementById(routeDeviceStateJSON.routeDeviceState.prevStop);

                    prev.innerHTML = prev.innerHTML + " (prev)";
                    
                    

                    
                    

					
				} else {
                    console.log("alla 2");
					
				}
			}
		};
        request.open('Get', 'http://eta.dynamictrackers.com:300/api/1.0/routes/deviceState/'+id);
        request.send();

    }

    function updateStopETA(id,cont){
        let request = new XMLHttpRequest();

        let rowStop = document.getElementById('stop'+cont);

        let rowStopName = document.getElementById('stopname'+cont);

        request.onreadystatechange = function () {


			
			if (request.readyState === 4) {
				if (request.status === 200 || request.status === 201) {
                    let stopJSON = JSON.parse(request.responseText);


                    rowStopName.innerHTML = stopJSON.arrival.stop.name;
                    rowStopName.id = stopJSON.arrival.stop._id;
                    let stopETA = moment(stopJSON.arrival.estimatedTime);
                    rowStop.innerHTML = stopETA.format("HH:mm:ss");

                    

					
				} else {
                    console.log("alla 2");
					
				}
			}
		};
        request.open('Get', 'http://eta.dynamictrackers.com:300/api/1.0/routes/stop/arrival/'+id);
        request.send();
    }


	function updateETA() {
		// set up a request
		let request = new XMLHttpRequest();

        let resp = document.getElementById('resp');

        //console.log(resp);
		
		request.onreadystatechange = function () {


			
			if (request.readyState === 4) {

				
				if (request.status === 200 || request.status === 201) {
      
					//resp.innerHTML = request.responseText;

                    let routeJSON = JSON.parse(request.responseText);

                    for(let i=0; i<routeJSON.routes.length; i++){
            
                        let cont = 1;
                        for(let j=0;j<routeJSON.routes[i].waypoints.length;j++){
              
              
                            if(routeJSON.routes[i].waypoints[j].isStop){
                          
                                updateStopETA(routeJSON.routes[i].waypoints[j]._id,cont);
                                cont++;
                            }
                        }
                        updateDeviceRouteState(routeJSON.routes[i].devices[0]);
                    }

					
				} else {
                    console.log("alla");
					
				}
			}
		};

        request.open('Get', 'http://eta.dynamictrackers.com:300/api/1.0/routes');
        request.send();

	}
    
    document.addEventListener("DOMContentLoaded", function() {
       
        updateETA();
      });
    
})();
